export default "__VITE_ASSET__EQKzvmrx__"